import React from 'react'
import { iFacadeApi } from '../../facade'

const ArqContext = React.createContext<iFacadeApi | null>(null)

export { ArqContext }
